import i18n from 'i18next';

// The Bulk Edit form contains a generic tooltip.
// This allows you to append additional content if needed.

export const getEnableTooltipTitle = (additionalContent: string) => {
  const baseTitle = i18n.t(
    'assets.selectFieldsTooltip',
    'Select fields you wish to change. Unselected fields will not be updated.'
  );
  return `${baseTitle}${additionalContent ? additionalContent : ''}`;
};
